import { Skeleton } from '@/design-system/skeleton';

export const DocumentSkeleton = () => {
  return (
    <div className="flex items-center gap-3">
      <Skeleton className="w-5 h-5 rounded" />
      <Skeleton className="h-4 w-[120px]" />
      <Skeleton className="h-3 w-[40px]" />
      <Skeleton className="h-3 w-[60px]" />
    </div>
  );
};
